import React from 'react';

import FormField from 'js/components/form_field';

import './index.scss';

export default function FormTextarea({label, required, placeholder, value, onChange}) {
    return (
        <FormField label={label} required={required}>
            <textarea
                className="form-textarea__textarea"
                placeholder={placeholder}
                defaultValue={value}
                onChange={onChange}
            />
        </FormField>
    );
}




// WEBPACK FOOTER //
// ./components/form_textarea/index.js